import React from "react";
import { PieChart, Pie, Cell } from "recharts";

type Props = {
  data: { name: string; value: number; fill: string }[];
};

const FullPieChart = ({ data }: Props) => {
  return (
    // D-10: charts keep their natural (LTR) orientation in both languages.
    <div dir="ltr" style={{ display: "inline-block" }}>
      <PieChart width={200} height={200}>
        <Pie
          data={data}
          cx={100}
          cy={100}
          labelLine={false}
          outerRadius={60}
          dataKey="value"
        >
          {data.map((entry) => (
            <Cell key={`cell-${entry.name}`} fill={entry.fill} />
          ))}
        </Pie>
      </PieChart>
    </div>
  );
};

export default FullPieChart;
